







import { Component, Vue, Mixins } from 'vue-property-decorator';
import VueHoduCommon from "@/mixin/VueHoduCommon";

import ManualContents from "@/components/manual/ManualContents.vue"
import ManualSection  from "@/components/manual/ManualSection.vue"

@Component({
    components: {
        ManualContents, ManualSection
    }
}) export default class Manual extends Mixins(VueHoduCommon) {

    beforeMount() : void {
        if( this.manual_tab == null || this.manual_tab.length < 1 ) { this.doSetManualTab(this.ManualTab.CALENDAR); }
    }

    mounted() : void {

    }

}

